import { LayerList } from "@pdfking/imposition"
import type { LayerID } from "@pdfking/renderer-api"
import { Keys } from "@pdfking/tfunc"

/** The layers a plot draws: only the printable ones when it prints, every one
 * when it is a template. */
export const PlotLayers = (printable: boolean): LayerID[] =>
  (Keys(LayerList) as LayerID[]).filter(id => !printable || LayerList[id]!.printable)
